import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './EnergySystem.css';

const products = [
    {
      name: "Sky Light",
      description: "Our Sky Light solutions provide natural lighting options designed to enhance indoor spaces with efficient, sustainable daylight. Engineered for durability and energy savings, these skylights are ideal for residential and commercial buildings. Key features include high-grade glazing for optimal light diffusion, UV protection to reduce fading, and robust materials to withstand various weather conditions. Perfect for creating brighter, healthier environments, our Sky Lights blend modern aesthetics with eco-conscious functionality.",
      main360Image: 'https://via.placeholder.com/300/FFCC00/FFFFFF?text=360+View',
      additionalImages: [
        require('../../../assets/skylight.jpg'),
        require('../../../assets/sky_light.png'),
      ],
      videoLink: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      name: "Solar Panels",
      description: "Our Solar Panels are built to harness solar energy efficiently, transforming sunlight into clean, renewable power. These panels are designed with advanced photovoltaic technology to maximize energy output while being durable enough to withstand harsh environmental conditions. With a focus on sustainability and performance, our Solar Panels are suitable for both residential and commercial applications, offering significant savings on energy bills and reducing carbon footprint. Experience the future of energy with high-efficiency, low-maintenance solar solutions.",
      main360Image: 'https://via.placeholder.com/300/007ACC/FFFFFF?text=360+View',
      additionalImages: [
        require('../../../assets/hvls.jpg'),
        require('../../../assets/hvls_png.png')
      ],
      videoLink: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
    {
      name: "XLPE Insulation",
      description: "Our XLPE Insulation solutions are crafted for superior thermal and electrical insulation, making them ideal for industrial, commercial, and residential applications. XLPE (Cross-Linked Polyethylene) insulation offers excellent resistance to heat, moisture, and chemicals, ensuring long-lasting durability and enhanced energy efficiency. This insulation is particularly effective for high-temperature environments and reduces energy costs by maintaining consistent temperatures. Choose XLPE Insulation for reliable, cost-effective thermal protection and exceptional performance.",
      main360Image: 'https://via.placeholder.com/300/007ACC/FFFFFF?text=360+View',
      additionalImages: [
        require('../../../assets/xlpe.png'),
        require('../../../assets/foam.jpg'),
        require('../../../assets/foam.png')
      ],
      videoLink: 'https://www.w3schools.com/html/mov_bbb.mp4'
    },
  ];
  

const EnergySystem = () => {
  const initialProductStates = products.map((product) => ({
    selectedImage: product.main360Image,
    isVideo: false,
  }));

  const [productStates, setProductStates] = useState(initialProductStates);


  useEffect(() => {
    if (productStates.length !== products.length) {
      setProductStates(initialProductStates);
    }
  }, [productStates, products, initialProductStates]);

  const handleVideoClick = (index) => {
    setProductStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, isVideo: true, selectedImage: null } : state
      )
    );
  };

  const handleImageClick = (image, index) => {
    setProductStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, selectedImage: image, isVideo: false } : state
      )
    );
  };

  return (
    <div className="ventilation-container">
      {products.map((product, index) => (
        <motion.div
          key={index}
          className={`product-section ${product.name.toLowerCase().replace(" ", "-")}`}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.4 }}
        >
          <motion.h1 
            className="product-title" 
            initial={{ scale: 0.8, opacity: 0 }} 
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
          >
            {product.name}
          </motion.h1>
          <div className="product-content">
            <div className="thumbnail-section">
              {product.additionalImages.map((image, i) => (
                <motion.img
                  key={i}
                  src={image}
                  alt={`${product.name} view ${i + 1}`}
                  className={`thumbnail ${productStates[index]?.selectedImage === image ? 'active' : ''}`}
                  onClick={() => handleImageClick(image, index)}
                  whileHover={{ scale: 1.15 }}
                  transition={{ duration: 0.3 }}
                />
              ))}
              <motion.button
                className="video-button"
                onClick={() => handleVideoClick(index)}
                whileHover={{ scale: 1.1, backgroundColor: "#f0c14b", color: "#111" }}
                transition={{ duration: 0.3 }}
              >
                Watch Video
              </motion.button>
            </div>
            <motion.div 
              className="main-image-container" 
              initial={{ opacity: 0, scale: 0.9 }} 
              animate={{ opacity: 1, scale: 1 }}
              transition={{ type: "spring", stiffness: 100, delay: 0.4 }}
            >
              {productStates[index]?.isVideo ? (
                <motion.video
                  className="current-video"
                  controls
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6 }}
                >
                  <source src={product.videoLink} type="video/mp4" />
                  Your browser does not support the video tag.
                </motion.video>
              ) : (
                <motion.img
                  src={productStates[index]?.selectedImage || product.main360Image}
                  alt={`${product.name} main view`}
                  className="current-frame"
                  initial={{ scale: 0.95, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                />
              )}
            </motion.div>
            <motion.div 
              className="product-text"
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <p>{product.description}</p>
            </motion.div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default EnergySystem;